import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../../../../config/config.js";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Futbol from "../components/Posiciones/Futbol";
import Voleibol from "../components/Posiciones/Voleibol";
import Basquetbol from "../components/Posiciones/Basquetbol";

import { formatIdSport } from "../../../../../utils/formatIdSport.js";

import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

const FullScreenModalConfigPosiciones = ({ open, setOpen }) => {
  const { idevent, idsport } = useParams();

  const formattedSport = formatIdSport(parseInt(idsport));

  const renderPositions = () => {
    switch (formattedSport) {
      case 1:
      case 2:
      case 5:
        return <Futbol />;
      case 3:
        return <Voleibol />;
      case 4:
        return <Basquetbol />;
      default:
        return <p>No hay datos de posiciones disponibles.</p>;
    }
  };

  const handleDefinirPosiciones = async () => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/patchdefinirposiciones`,
        {
          idevent,
          idsport,
        }
      );
      toast.success("¡Tabla de posiciones definida exitosamente!");
      setOpen(false); // Cierra el modal si lo deseas después de la operación
    } catch (error) {
      toast.error("Error al definir la tabla de posiciones");
      console.error("Error al definir la tabla de posiciones:", error);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <ModalDialog layout="fullscreen">
          <ModalClose sx={{ width: "35px" }} />
          <DialogTitle className="text-2xl font-bold text-gray-800">
            Configuración para Fase Final por Posiciones
          </DialogTitle>
          <DialogContent>
            <div>
              <div className="mb-4 flex justify-evenly space-x-4">
                <button
                  className="bg-red-400 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                  onClick={handleDefinirPosiciones}
                >
                  1. Definir Tabla de Posiciones
                </button>
              </div>
              <div>{renderPositions()}</div>
            </div>
          </DialogContent>
        </ModalDialog>
      </Modal>
    </>
  );
};

export default FullScreenModalConfigPosiciones;
